
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsPromoAvMbDialog extends Serenity.EntityDialog<PsPromoAvMbRow, any> {
        protected getFormKey() { return PsPromoAvMbForm.formKey; }
        protected getIdProperty() { return PsPromoAvMbRow.idProperty; }
        protected getLocalTextPrefix() { return PsPromoAvMbRow.localTextPrefix; }
        protected getNameProperty() { return PsPromoAvMbRow.nameProperty; }
        protected getService() { return PsPromoAvMbService.baseUrl; }
        protected getDeletePermission() { return PsPromoAvMbRow.deletePermission; }
        protected getInsertPermission() { return PsPromoAvMbRow.insertPermission; }
        protected getUpdatePermission() { return PsPromoAvMbRow.updatePermission; }

        protected form = new PsPromoAvMbForm(this.idPrefix);

    }
}